import React, { useMemo } from "react";

import moment from "moment";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import usePeriodFilter from "@/src/hooks/usePeriodFilter";

import BandwidthTimelineCard from "./BandwidthTimelineCard";
import QuotasSection from "./QuotasSection";
import UsageKpiGrid from "./UsageKpiGrid";
import PageTitle from "../../common/PageTitle";
import AnalyticsPage from "../AnalyticsPage";
import AnalyticsPeriodPicker from "../charts/AnalyticsPeriodPicker";

import type { JSX } from "react";

import type { AppState } from "@/src/reducers";

function UsageAdmin(): JSX.Element {
  const { t } = useTranslation("editor-analytics");
  const organizationCreationDate = useSelector(
    (state: AppState) =>
      state.fetchReducer.orga_config.data?.organization_creation_date,
  );
  const minDate = useMemo(
    () => (organizationCreationDate ? moment(organizationCreationDate) : null),
    [organizationCreationDate],
  );
  const { period, setPeriod } = usePeriodFilter();

  return (
    <AnalyticsPage
      heading={<PageTitle>{t("editor-menu:insights")}</PageTitle>}
      actions={
        <AnalyticsPeriodPicker
          minDate={minDate}
          onChange={setPeriod}
          period={period}
        />
      }
    >
      <UsageKpiGrid period={period} />
      <QuotasSection period={period} />
      <BandwidthTimelineCard period={period} />
    </AnalyticsPage>
  );
}

export default UsageAdmin;
